import React from 'react'
import _ from 'lodash'
import { Modal, Menu, Form } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { app, use } from 'xadmin'

const convertFrom = (str, obj, isFrist) => {
  // obj.required = []
  if (!obj) return {}
  if (isFrist) obj.form = []
  if (str.indexOf('.') == -1) {
    obj?.form?.indexOf(str) == -1 && obj?.form?.push(str)
    obj.form = obj?.form?.filter(j => j != '*')
    return obj
  } else {
    const or = str.split('.')
    const k = or[0]
    const t = or.slice(1, or.length)
    obj.form?.indexOf(k) == -1 && obj?.form?.push(k)
    obj.form = obj?.form?.filter(j => j != '*')
    if (t.length > 0) obj.properties[k] = convertFrom(t.join('.'), obj.properties[k], false)
    return obj
  }
}

const findBatchChangeFields = properties => {
  if (properties.custom) {
    return {
      ...properties,
      custom: {
        ...(properties.custom || {}),
        form: properties?.custom?.batchChangeFields || []
      }
    }
  } else {
    return properties
  }
}

const BatchChangeBtn = props => {
  const { _t } = app.context
  const [show, setShow] = React.useState(false)
  const { canEdit, fields, onBatchChange } = use('actons.batch_change', props)
  const { selected } = use('model.select', props)
  const { model } = use('model', props)

  const onClose = () => setShow(false)

  const onSubmit = values => {
    let convertValues = {}
    // custom字段特殊处理
    values && Object.keys(values).forEach(v => {
      if (v == 'custom') {
        Object.keys(values[v]).forEach(cv => {
          convertValues = { ...convertValues, [v + '.' + cv]: values[v][cv] }
        })
      } else {
        convertValues = { ...convertValues, [v]: values[v] }
      }
    })
    return onBatchChange(convertValues)
  }

  const renderModel = () => {
    const properties = findBatchChangeFields(model.properties)
    const schema = {
      key: model.key,
      name: model.name,
      resource: model.resource,
      properties,
      required: model?.required?.filter(r => fields?.indexOf(r) >= 0),
      type: 'object'
    }
    fields.forEach((f, i) => convertFrom(f, schema, i == 0))
    return (
      <SchemaForm key="actions_batch_change_form" formKey={`model_batch.${model.key}`}
        schema={schema}
        onSubmit={onSubmit}
        onSubmitSuccess={onClose}
        onClose={onClose}>
        {({ children, invalid, handleSubmit, submitting, onClose }) => (
          <Modal key="actions_batch_change_modal" visible={show} onClose={onClose}
            title={_t('Please input the value to batch change items')}
            okText={_t('Change')}
            onOk={handleSubmit}
            okButtonProps={{ disabled: invalid || submitting }}
            cancelText={_t('Cancel')}
            onCancel={onClose}
          >
            <Form onSubmit={handleSubmit}>{children}</Form>
          </Modal>
        )}
      </SchemaForm>
    )
  }

  return (canEdit && fields.length > 0) ? [(
    <Menu.Item {...props} key="actions_batch_change"
      onClick={(e) => {
        props.onClick && props.onClick(e)
        setShow(true)
      }} disabled={selected.length == 0}>
      {_t('Batch Change Items')}
    </Menu.Item>
  ),
  selected.length > 0 ? renderModel() : null
  ] : null

}

export default BatchChangeBtn
